import { isDefined, isUndefined } from '../../../utils/isDefined';

const mapTemplateCharacteristic = template => {
  if (isUndefined(template?.attributes)) {
    return {};
  }

  const { attributes } = template;
  const has = name => isDefined(attributes.find(attr => attr.name === name));

  return {
    hasActivateEsim: has('phone-and-sim-card.esim-signup-primary'),
    hasPrimarySimCard: has('phone-and-sim-card.resources-sim-cards-primary'),
    hasDataSharingEsim: has('phone-and-sim-card.esim-signup-extra-1'),
    hasDataSharingSimCard: has(
      'phone-and-sim-card.resources-sim-cards-extra-1'
    ),
    dataSharingCards: [1, 2, 3].map(cardNumber => ({
      hasEsim: has(`phone-and-sim-card.esim-signup-extra-${cardNumber}`),
      hasSimCard: has(
        `phone-and-sim-card.resources-sim-cards-extra-${cardNumber}`
      )
    })),
    hasRefill: has('main-package.mp-refill')
  };
};

export default mapTemplateCharacteristic;
